/**
 * @generated SignedSource<<53743b7a3313cb629530bad18a5b803a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ResendAccessCodesMutation$variables = {
  orderId: string;
  tenantId: string;
};
export type ResendAccessCodesMutation$data = {
  readonly resendAccessCode: {
    readonly message: string | null;
    readonly success: boolean;
  };
};
export type ResendAccessCodesMutation = {
  response: ResendAccessCodesMutation$data;
  variables: ResendAccessCodesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tenantId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "orderId",
        "variableName": "orderId"
      },
      {
        "kind": "Variable",
        "name": "tenantId",
        "variableName": "tenantId"
      }
    ],
    "concreteType": "AdminResult",
    "kind": "LinkedField",
    "name": "resendAccessCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResendAccessCodesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResendAccessCodesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9070d4c75eed3b228b8191ee8a208f92",
    "id": null,
    "metadata": {},
    "name": "ResendAccessCodesMutation",
    "operationKind": "mutation",
    "text": "mutation ResendAccessCodesMutation(\n  $orderId: String!\n  $tenantId: String!\n) {\n  resendAccessCode(orderId: $orderId, tenantId: $tenantId) {\n    success\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "acfe9e51b1236221e7c3f2ff9a3237d9";

export default node;
